import {environment} from "../../environments/environment";
import {Bank} from "../../model/basicos/Bank";
import {HttpClient} from "@angular/common/http";
import {OAuthService} from "angular-oauth2-oidc";
import {Injectable} from "@angular/core";

@Injectable()
export class BanksProvider {

  apiBank: string = "/general-data/v1/bank";

  constructor(public http: HttpClient, public oauthService: OAuthService) {

  }

  getAllBanks() {
    return new Promise((resolve, reject) => {
      this.http.get(`${environment.apiLogin}${this.apiBank}`,
        {headers: {Authorization: this.oauthService.authorizationHeader()}})
        .subscribe((result: Bank[]) => {
            resolve(result);
          },
          (error) => {
            reject(error);
          });
    });
  }

  getBankById(idBank: number) {
    return new Promise((resolve, reject) => {
      this.http.get(`${environment.apiLogin}${this.apiBank}/${idBank}`,
        {headers: {Authorization: this.oauthService.authorizationHeader()}})
        .subscribe((result: Bank[]) => {
            resolve(result);
          },
          (error) => {
            reject(error);
          });
    });
  }

}
